import { Gto } from "./gto";
import { Beneficiario } from "./beneficiario";
import { FormularioOrtodontia } from "./formulario-ortodontia";
import { PrestadorExecutante } from "./prestador-executante";
import { Procedimentos } from "./procedimentos";
import { AnexoGtoVO } from "./anexo-gto";
import { DentistaRadiologia } from "./dentista-radiologia";

export class NovaGto {
    constructor(
        public codigoStep?: number,
        public beneficiario?: Beneficiario,
        public listaProcedimentos?: Array<Procedimentos>,
        public tipoAtendimento?: any,
        public anexos?: AnexoGtoVO[],
        public observacoesTratamento?: string,
        public primeiraOrtodontia?: boolean,
        public prorrogacaoOrtodontia?: boolean,
        public prestExecutante?: PrestadorExecutante,
        public formularioOrtodontia?: FormularioOrtodontia,
        public dentistaRadiologia?: DentistaRadiologia,
        public disabledTipoAtendimento?: boolean
    ){
    	this.anexos = [];
    }
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/nova-gto.ts